(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["evanny-card-tones"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ev-card-tones')) {
    customElements.define('ev-card-tones', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.ev-card-tones__slide')];
        if (this.slides.length < 2) return;
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-current')));
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.card = this.closest('.card-wrapper') || this;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.schedule = this.schedule.bind(this);
        this.card.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') {
            this.hovered = true;
            this.schedule();
          }
        }, options);
        this.card.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.schedule();
        }, options);
        this.card.addEventListener('focusin', () => {
          this.focused = true;
          this.schedule();
        }, options);
        this.card.addEventListener('focusout', event => {
          this.focused = this.card.contains(event.relatedTarget);
          this.schedule();
        }, options);
        this.reduced.addEventListener('change', this.schedule, options);
        document.addEventListener('visibilitychange', this.schedule, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: .2 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.events?.abort();
      }
      prepare(index) {
        const slide = this.slides[index];
        const template = slide.querySelector('template');
        if (template) {
          const content = template.content.cloneNode(true);
          const image = content.querySelector('img');
          if (image) image.loading = 'eager';
          template.replaceWith(content);
        }
        return slide.querySelector('img');
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.visible || this.hovered || this.focused || this.reduced.matches || document.hidden) return;
        const next = (this.index + 1) % this.slides.length;
        this.prepare(next);
        this.timer = setTimeout(() => {
          const image = this.prepare(next);
          if (image?.complete && image.naturalWidth) {
            this.slides[this.index].classList.remove('is-current');
            this.slides[next].classList.add('is-current');
            this.index = next;
          }
          this.schedule();
        }, 1500);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
